import { gql } from '@apollo/client';

import { professorActivityAnswerFragment } from '../fragments';
import { ProfessorActivityAnswer } from '../../types';

export interface GetActivityAnswersQueryVariables {
  courseId: string;
  activityId: string;
}

export interface GetActivityAnswersQueryResult {
  answers: ProfessorActivityAnswer[];
}

export const getActivityAnswersQuery = gql`
  query GetActivityAnswersQuery($courseId: String!, $activityId: String!) {
    answers(courseId: $courseId, activityId: $activityId)
      @rest(type: "ActivityAnswer", path: "courses/{args.courseId}/activities/{args.activityId}/answers") {
      ...ProfessorActivityAnswer
    }
  }
  ${professorActivityAnswerFragment}
`;
